import { Component, HostBinding } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-tertiary-button',
  templateUrl: './tertiary-button.component.html',
})
export class TertiaryButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-tertiary-button') hostBaseClass = true;
}
